import React from 'react';
import { Redirect } from 'react-router';

import { lazyWithDelay } from './lazyWithDelay';
import { routesTypes } from './';

export const routes: routesTypes.Route[] = [
  {
    path: routesTypes.Config.HOME,
    exact: true,
    component: lazyWithDelay(() =>
      import(
        '@pages/Home'
      )
      .then(res => ({
        default: res.HomePage
      })),
    ),
    name: 'Главная',
  },
  {
    path: routesTypes.Config.SHIELD,
    exact: true,
    component: lazyWithDelay(() =>
      import(
        '@pages/Shield'
      )
      .then(res => ({
        default: res.ShieldPage
      })),
    ),
    name: 'Надежный щит России',
  },
  {
    path: routesTypes.Config.PEOPLE,
    exact: true,
    component: lazyWithDelay(() =>
      import(
        '@pages/People'
      )
      .then(res => ({
        default: res.PeoplePage
      })),
    ),
    name: 'Люди',
  },
  {
    path: routesTypes.Config.PARITY,
    exact: true,
    component: lazyWithDelay(() =>
      import(
        '@pages/Parity'
      )
      .then(res => ({
        default: res.ParityPage
      })),
    ),
    name: 'Путь к паритету',
  },
  {
    path: routesTypes.Config.SCIENCE,
    exact: true,
    component: lazyWithDelay(() =>
      import(
        '@pages/Science'
      )
      .then(res => ({
        default: res.SciencePage
      })),
    ),
    name: 'Хайтек и наука',
  },
  {
    path: routesTypes.Config.WORK,
    exact: true,
    component: lazyWithDelay(() =>
      import(
        '@pages/Work'
      )
      .then(res => ({
        default: res.WorkPage
      })),
    ),
    name: 'Боевая работа',
  },
];